/**
 * The line icons that stand in for text symbols (ingo-e0, 2 Oct 2026; Rio:
 * "no emojis"): a tick and a close, drawn like the app's other icons (24-grid,
 * round caps, `currentColor`), so they take the colour and size of the text
 * they replace. Decorative: the control around them carries the name.
 */

export function IconCheck({ size = 18, strokeWidth = 2.4 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" aria-hidden focusable="false">
      <path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function IconClose({ size = 16, strokeWidth = 2.2 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" aria-hidden focusable="false">
      <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" />
    </svg>
  );
}

/** The same close, as markup for the one surface drawn with innerHTML (the fallback offer banner). */
export const CLOSE_ICON_MARKUP =
  '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
